import BlockGroup from './BlockGroup';
// import CustomBlock from './CustomBlock';
import GiftBoxes from './GiftBoxes';
import Hero from './Hero';
import './main.scss';

import { bodyContent } from './data/bodyContent';
import LazyLoadMap from './LazyLoadMap';

const App = () => {
  return (
    <>
      <div class='cf-section--apples-1'></div>
      <div class='cf-section--apples-2'></div>
      <article className=' page type-page status-publish hentry entry'>
        <div className='entry-content cf--tasting-room'>
          <Hero />
          <BlockGroup data={bodyContent} />
        </div>

        <GiftBoxes />
        {/* <CustomBlock /> */}

        <div className='wp-block-group cf--side-by-side is-layout-flow wp-block-group-is-layout-flow'>
          <div className='wp-block-group__inner-container'>
            <div className='wp-block-group is-layout-flow wp-block-group-is-layout-flow'>
              <div className='wp-block-group__inner-container'>
                <section className='cf-content-box cf-location'>
                  <div>
                    <h2 className='wp-block-heading'>Location</h2>

                    <p>8216 Watts Rd</p>
                    <p>Madison, WI 53719</p>
                    <br />
                    <p>
                      * <em>next to Brennan's</em>
                    </p>
                  </div>
                  <LazyLoadMap />
                </section>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default App;
